import { Filter } from '../../models';

export const researchFilter: Filter[] = [
  {
    title: 'Research area',
    type: 'checkbox',
    field: 'research_area.keyword', // TODO: Verify actual field name in Elasticsearch
    options: [
      { title: 'Agriculture & environment', value: 'Agriculture and environment' },
      { title: 'Biomedical & clinical science', value: 'Biomedical and clinical science' },
      { title: 'Business, society & community', value: 'Business, society and community' },
      { title: 'Chemical science', value: 'Chemical science' },
      { title: 'Defence', value: 'Defence' },
      { title: 'Digital transformation', value: 'Digital transformation' },
      { title: 'Energy transition', value: 'Energy transition' },
      { title: 'Health data to knowledge', value: 'Health data to knowledge' },
      { title: 'Healthy communities', value: 'Healthy communities' },
      { title: 'Resources, mining & minerals', value: 'Resources, mining and minerals' },
      { title: 'Space', value: 'Space' },
      { title: 'Structural engineering & monitoring', value: 'Structural engineering & monitoring' },
      { title: 'Sustainable development', value: 'Sustainable development' },
    ],
  },
  {
    title: 'Research type',
    type: 'checkbox',
    field: 'research_type.keyword', // TODO: Verify actual field name in Elasticsearch
    metadataField: 'research_type',
    options: [
      { title: 'Centre of excellence', value: 'Centre of excellence' },
      { title: 'Cooperative research centre', value: 'Cooperative research centre' },
      { title: 'Facility', value: 'Facility' },
      { title: 'Industry research centre', value: 'Industry research centre' },
      { title: 'Multi-institutional research centre', value: 'Multi-institutional research centre' },
      { title: 'Research centre', value: 'Research centre' },
      { title: 'Research group', value: 'Research group' },
      { title: 'Research institute', value: 'Research institute' },
    ],
  },
  {
    title: 'Research faculty',
    type: 'checkbox',
    field: 'research_faculty.keyword', // TODO: Verify actual field name in Elasticsearch
    metadataField: 'research_faculity',
    options: [
      { title: 'Business & law', value: 'Business and Law' },
      { title: 'Health sciences', value: 'Health Sciences' },
      { title: 'Humanities', value: 'Humanities' },
      { title: 'Science & engineering', value: 'Science and Engineering' },
    ],
  },
];
